<div class="container-fluid">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <div class="forms d-block comparewiki-table-header">

    <div class="row m-0">
      <div class="col-lg-12">
        <div [formGroup]="form1" class="forms d-block">
          <div class="row m-0">
            <div class="col-lg-12 d-flex pl-0">
              <span class="p-float-label my-2 me-2 mt-2 d-block">
                <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
                  [options]="shortTermRentals" formControlName="shortTermRentalIds" defaultLabel="Select Property"
                  dataKey="shortTermRentalId" id="shortTermRentalIds" optionLabel="propertyCode" display="chip"
                  appendTo="body">
                </p-multiSelect>
                <label for="shortTermRentalIds">Select Property</label>
              </span>
              <span class="p-float-label my-2 me-2">
                <p-calendar inputId="checkInDate" formControlName="checkInDate" (onSelect)="onDateChange()" [style]="{'width':'200px'}"
                  appendTo="body">
                </p-calendar>
                <label for="checkInDate">Start-Date</label>
              </span>
              <span class="p-float-label my-2 me-2">
                <p-calendar #checkOutDateCal inputId="checkOutDate" formControlName="checkOutDate" [style]="{'width':'200px'}"
                  appendTo="body" [minDate]="minDate" [defaultDate]="minDate">
                </p-calendar>
                <label for="checkOutDate">End-Date</label>
              </span>
              <div class="btn-group">
                <div class="button-group">
                  <button pButton class="btn-addt p-button" (click)="formSearch()">Search</button>
                </div>
              </div>


            </div>
          </div>
          <!-- <div class="row m-0">
          <div class="col-lg-12">
            <div class="btn-group">
              <div class="button-group">
                <button pButton class="btn-addt p-button" (click)="formSearch()">Search</button>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <p-table #dt2 class="kbmadmintable" #pt [value]="reservations" dataKey="compareWikiReservationLedgerId" selectionMode="single"
        [(selection)]="compareReservationLedger" [loading]="loading" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
        scrollHeight="900px" [globalFilterFields]="['propertyCode', 'reservationId', 'guestName', 'reservationStatus']"
        [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

        <!--<ng-template pTemplate="caption">
        <div class="row m-0">
          <div class="col-lg-12">
            <div class="d-block text-end justify-content-between align-items-center">
              <h1 style="float: left;margin: 6px;">CompareWikiReservationLedgers</h1>
              <span>
                &lt;!&ndash;clear filters&ndash;&gt;
                <button *ngIf="showFilter" pButton pRipple class="p-button-text"
                  style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
                (click)="reloadPage()">Clear Filters</button>

                &lt;!&ndash;add new&ndash;&gt;
                &lt;!&ndash; <button *ngIf="!outlineNewButton" pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
              (click)="onOpenFormAdd()">New CompareWikiReservationLedger +</button>
              <button *ngIf="outlineNewButton" pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
              (click)="onOpenFormAdd()">New CompareWikiReservationLedger +</button> &ndash;&gt;
            </span>
          </div>
        </div>
      </div>
    </ng-template>-->
    <ng-template pTemplate="caption">
      <div class="flex">
        <p-iconField iconPosition="left" class="ml-auto position-relative">
          <p-inputIcon>
            <span class="p-input-icon">
              <i class="pi pi-search"></i>
            </span>

          </p-inputIcon>
          <input
            pInputText
            type="text"
            (input)="dt2.filterGlobal($event.target.value, 'contains')"
            placeholder="Search keyword" />
        </p-iconField>
        <app-import-export importEnabled="false" [dataRetrived]="reservations" (exportDataSelected)="exportSelected($event)" [columns]="columns" [importDisabled]="true"></app-import-export>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
          </th>
        }
        <th>Actions</th>
        <th>Channel</th>
      </tr>
      <tr>
        <th class="propertycode-filter">
          <p-columnFilter
            type="text"
            [showMenu]="false"
            matchMode="contains"
            field="propertyCode"
            placeholder="Property name"
            ariaLabel="Property name">
          </p-columnFilter>
        </th>
        <th >
          <p-columnFilter
            field="createDate" [showMenu]="false" >
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input dt2 [(ngModel)]="createDate" pInputText type="date"
                (input)="filter($event.target.value, 'createDate', 'in')">
            </ng-template>
          </p-columnFilter>
        </th>
        <th class="filter-input">
          <p-columnFilter
            type="text"
            field="orderId"
            matchMode="contains"
            [showMenu]="false"
            placeholder="orderId"
          ariaLabel="orderId"></p-columnFilter>
        </th>
        <th class="filter-input">
          <p-columnFilter
            type="text"
            matchMode="contains"
            [showMenu]="false"
            field="reservationId"
            placeholder="reservation #"
          ariaLabel="reservationId"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter field="reservationStatus" matchMode="equals" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown dt2
                [(ngModel)]="reservationStatus1"
                [options]="reservationStatuses"
                (onChange)="filter($event.value, 'reservationStatus', 'in')"
                placeholder="Select"
                [showClear]="true" appendTo="body" optionLabel="name" optionValue="value">
                <ng-template let-option pTemplate="item">
                  <span>{{option.name}}</span>
                </ng-template>
              </p-dropdown>
            </ng-template>
          </p-columnFilter>
        </th>
        <th class="filter-input">
          <p-columnFilter
            type="text"
            field="guestName"
            matchMode="contains"
            [showMenu]="false"
            placeholder="Guest Name"
            ariaLabel="guestName">
          </p-columnFilter>
        </th>
        <th>
          <p-columnFilter
            field="checkInDate" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input dt2 [(ngModel)]="checkInDate" pInputText type="date"
                (input)="filter($event.target.value, 'checkInDate', 'in')">
            </ng-template>
          </p-columnFilter>
        </th>
        <th>
          <p-columnFilter
            field="checkOutDate" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input dt2 [(ngModel)]="checkOutDate" pInputText type="date"
                (input)="filter($event.target.value, 'checkOutDate', 'in')">
            </ng-template>
          </p-columnFilter>
        </th>
        <th class="filter-input">
          <p-columnFilter
            type="text"
            matchMode="contains"
            [showMenu]="false"
            field="invoiceTotal"
            placeholder="Invoice Total"
          ariaLabel="invoiceTotal"></p-columnFilter>
        </th>
        <th class="filter-input">
          <p-columnFilter
            type="text"
            matchMode="contains"
            [showMenu]="false"
            field="ledgerTotal"
            placeholder="Ledger Total"
          ariaLabel="ledgerTotal"></p-columnFilter>
        </th>
        <th class="filter-input">
          <p-columnFilter
            type="text"
            matchMode="contains"
            [showMenu]="false"
            field="paymentReceived"
            placeholder="Payment Received"
          ariaLabel="paymentReceived"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="boolean" field="locked"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="boolean" field="balanced"></p-columnFilter>
        </th>
        <th>Action</th>
        <th>Channel</th>


      </tr>
      <!--<tr *ngIf="showFilter">
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'compareWikiReservationLedgerId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>-->
  </ng-template>
  <ng-template pTemplate="body" let-reservation>
    @if (!reservation.hide) {
      <tr>
        <td>{{reservation?.propertyCode}} </td>
        <td>{{reservation?.createDate | date}}</td>
        <td> <a href="https://admin.kbmhawaii.com/order/{{reservation?.orderId}}" target="_blank">{{reservation?.orderId}} </a></td>
        <td> <a href="https://new.rentalsunited.com/MyBookings/Edit/{{reservation?.ruReservationId}}" target="_blank">{{reservation?.reservationId}}</a></td>
        <td [style.background-color]="getResStatusColor(reservation.reservationStatus)">
        {{getResStatusName(reservation.reservationStatus)}}</td>
        <td>{{reservation?.guestName}}</td>
        <td>{{reservation?.checkInDate | date}}</td>
        <td>{{reservation?.checkOutDate | date}}</td>
        <td>{{reservation?.invoiceTotal | currency : 'USD'}}</td>
        <td>{{reservation?.ledgerTotal | currency : 'USD'}}</td>
        <td>{{reservation?.paymentReceived | currency : 'USD'}}</td>
        <td>
          <i class="pi {{reservation?.locked ? 'pi-lock' : 'pi-lock-open'}}" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"></i>
        </td>
        <td [style.background-color]="getSyncColor(reservation)">
          {{getDiscripancyAmt(reservation) | currency : 'USD'}}
        </td>
        <td>
          <span style="float:none">
            <a>
              <i class="pi pi-refresh" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="refresh(reservation)"></i>
            </a>
          </span>
          <span style="float:none">
            <a>
              <i class="pi pi-info-circle" title="Invoice" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="openInvoice(reservation)"></i>
            </a>
          </span>
          <span style="float:none">
            <a>
              <i class="pi pi-book" title="Ledger" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="openLedger(reservation)"></i>
            </a>
          </span>
          <span style="float:none">
            <a>
              <i class="pi pi-replay" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="generateLedgers(reservation)" title="ReGenerateLedger"></i>
            </a></span>
          </td>
          <td><img style='height: 20px; width: 80px' src='{{constantService.getChannelPictureURL(reservation.referralSourceId)}}'/></td>
        </tr>
      }
    </ng-template>
  </p-table>
</div>
</div>
</div>
</div>
